import { useState, FC, ReactNode } from 'react';
import { ToTop } from '../modules';

type SectionProps = {
    title: string;
    children: ReactNode;
};

const Section: FC<SectionProps> = ({ title, children }) => (
    <section style={{ marginBottom: '2.5rem' }}>
        <h2
            className="privacypolicy_contents_h2"
            style={{
                borderBottom: '2px solid #eee',
                paddingBottom: '0.5rem',
                marginBottom: '1.5rem',
            }}
        >
            {title}
        </h2>
        <div style={{ lineHeight: 1.8, color: '#555' }}>{children}</div>
    </section>
);

type PolicyHeaderProps = {
    title: string;
    subTitle: string;
    lastUpdate: string;
};

const PolicyHeader: FC<PolicyHeaderProps> = ({
    title,
    subTitle,
    lastUpdate,
}) => (
    <header style={{ textAlign: 'center', marginBottom: '4rem' }}>
        <h1 className="privacypolicy_title" style={{ marginBottom: '0.5rem' }}>
            {title}
        </h1>
        <h2
            className="privacypolicy_subTitle"
            style={{ marginBottom: '1rem', color: '#666' }}
        >
            {subTitle}
        </h2>
        <p
            className="privacypolicy_contents_body"
            style={{ color: '#888', fontSize: '0.9rem' }}
        >
            {lastUpdate}
        </p>
    </header>
);

type LangButtonProps = {
    onClick: () => void;
    isActive: boolean;
    children: ReactNode;
    style?: React.CSSProperties;
};

const LangButton: FC<LangButtonProps> = ({
    onClick,
    isActive,
    children,
    style,
}) => (
    <button
        onClick={onClick}
        style={{
            ...style,
            padding: '8px 16px',
            cursor: 'pointer',
            border: isActive ? '1px solid #333' : '1px solid #ccc',
            backgroundColor: isActive ? '#333' : 'white',
            color: isActive ? 'white' : '#333',
            borderRadius: '4px',
            transition: 'all 0.3s',
            minWidth: '110px',
            whiteSpace: 'nowrap',
            height: '40px',
        }}
    >
        {children}
    </button>
);

const TukanomaTermsOfService: FC = () => {
    const [lang, setLang] = useState<'jp' | 'en'>('jp');

    // 日本語コンテンツ
    const jpContent = {
        title: 'Tukanoma Camera',
        subTitle: '利用規約',
        lastUpdate: '最終更新日: 2025年11月29日',
        section1Title: '第1条（はじめに）',
        section1Body:
            'この利用規約（以下「本規約」といいます。）は、「Tukanoma Camera」（以下「本アプリ」といいます。）の利用条件を定めるものです。本アプリを利用するすべてのユーザー（以下「ユーザー」といいます。）は、本規約に同意の上、本アプリを利用するものとします。',
        section2Title: '第2条（本アプリの利用）',
        section2_1Li:
            '本アプリは、ユーザーが指定した秒数に基づいて、短い動画を撮影し、自身のデバイスに保存する機能を提供します。',
        section2_2Li:
            'ユーザーは、自身の責任において本アプリを利用するものとし、本アプリを利用して作成したコンテンツ（動画など）について一切の責任を負うものとします。',
        section3Title: '第3条（有料機能）',
        section3_1Li:
            '本アプリは、アプリ内課金により利用可能となるプレミアム機能（以下「有料機能」といいます。）を提供します。有料機能の内容は、アプリ内の説明ページに記載します。',
        section3_2Li:
            '有料機能の購入は、Apple Inc.が提供する決済システムを通じて行われ、その支払いに関してはAppleの利用規約が適用されます。',
        section3_3Li:
            'ユーザーは、購入済みの有料機能を、Appleのシステムを通じて復元することができます。',
        section4Title: '第4条（禁止事項）',
        section4Body: 'ユーザーは、本アプリの利用にあたり、以下の行為をしてはなりません。',
        section4_1Li: '法令または公序良俗に違反する行為。',
        section4_2Li: '犯罪行為に関連する行為。',
        section4_3Li:
            '本アプリのサーバーまたはネットワークの機能を破壊したり、妨害したりする行為。',
        section4_4Li: '本アプリの運営を妨害するおそれのある行為。',
        section4_5Li: '不正な方法で有料機能を利用しようとする行為。',
        section4_6Li: '本アプリの著作権、商標権その他の知的財産権を侵害する行為。',
        section4_7Li: '他人の著作権を侵害するコンテンツを作成、配布する行為。',
        section4_8Li: 'その他、開発者が不適切と判断する行為。',
        section5Title: '第5条（知的財産権）',
        section5Body:
            '本アプリに関する著作権その他の知的財産権は、すべて開発者に帰属します。ユーザーは、法令で認められる私的利用の範囲を超えて、無断で複製、送信、改変などを行うことはできません。',
        section6Title: '第6条（免責事項）',
        section6_1Li:
            '開発者は、本アプリに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを、明示的にも黙示的にも保証しておりません。',
        section6_2Li:
            '開発者は、本アプリに起因してユーザーに生じたあらゆる損害について、一切の責任を負いません。',
        section7Title: '第7条（利用規約の変更）',
        section7Body:
            '開発者は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。変更後の利用規約は、本アプリ内に表示した時点から効力を生じるものとします。',
        section8Title: '第8条（連絡先）',
        section8Body:
            '本規約に関するお問い合わせは、以下の連絡先までお願いします。\nbrownpowder@gmail.com',
    };

    // 英語コンテンツ
    const enContent = {
        title: 'Tukanoma Camera',
        subTitle: 'Terms of Service',
        lastUpdate: 'Effective as of November 29, 2025',
        section1Title: 'Article 1 (Introduction)',
        section1Body:
            'These Terms of Service (hereinafter referred to as "Terms") set forth the terms and conditions for using "Tukanoma Camera" (hereinafter referred to as "the App"). All users (hereinafter referred to as "Users") who use the App shall use the App upon agreeing to these Terms.',
        section2Title: 'Article 2 (Use of the App)',
        section2_1Li:
            'The App provides a function to record short videos based on the number of seconds specified by the User and save them to their own device.',
        section2_2Li:
            'Users shall use the App at their own responsibility and shall bear all responsibility for the content (videos, etc.) created using the App.',
        section3Title: 'Article 3 (Paid Features)',
        section3_1Li:
            'The App provides premium features (hereinafter referred to as "Paid Features") that become available through in-app purchases. The details of the Paid Features are described on the explanation page within the App.',
        section3_2Li:
            'The purchase of Paid Features is conducted through the payment system provided by Apple Inc., and Apple\'s terms and conditions apply to such payments.',
        section3_3Li:
            'Users can restore purchased Paid Features through Apple\'s system.',
        section4Title: 'Article 4 (Prohibited Acts)',
        section4Body:
            'Users must not engage in the following acts when using the App:',
        section4_1Li: 'Acts that violate laws and regulations or public order and morals.',
        section4_2Li: 'Acts related to criminal activities.',
        section4_3Li:
            'Acts that destroy or interfere with the functions of the App\'s server or network.',
        section4_4Li: 'Acts that may interfere with the operation of the App.',
        section4_5Li: 'Acts of attempting to use Paid Features by unauthorized methods.',
        section4_6Li:
            'Acts that infringe on the copyrights, trademark rights, or other intellectual property rights of the App.',
        section4_7Li:
            'Acts of creating or distributing content that infringes on the copyrights of others.',
        section4_8Li: 'Other acts that the Developer deems inappropriate.',
        section5Title: 'Article 5 (Intellectual Property Rights)',
        section5Body:
            'All copyrights and other intellectual property rights related to the App belong to the Developer. Users may not reproduce, transmit, modify, etc., the App without permission beyond the scope of private use permitted by law.',
        section6Title: 'Article 6 (Disclaimer)',
        section6_1Li:
            'The Developer does not guarantee, either expressly or implicitly, that the App is free from de facto or legal defects (including defects related to safety, reliability, accuracy, completeness, effectiveness, fitness for a particular purpose, security, etc., errors or bugs, infringement of rights, etc.).',
        section6_2Li:
            'The Developer shall not be responsible for any damages incurred by the User arising from the App.',
        section7Title: 'Article 7 (Changes to Terms of Service)',
        section7Body:
            'The Developer may change these Terms at any time without notifying the User if deemed necessary. The modified Terms of Service shall take effect from the time they are displayed within the App.',
        section8Title: 'Article 8 (Contact Information)',
        section8Body:
            'For inquiries regarding these Terms, please contact the following:\nbrownpowder@gmail.com',
    };

    const currentContent = lang === 'jp' ? jpContent : enContent;

    return (
        <div
            className="privacypolicy"
            style={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: '#fff',
                padding: '4rem 2rem',
            }}
        >
            <ToTop />
            <div
                className="privacypolicy_contents"
                style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    fontFamily: 'sans-serif',
                }}
            >
                <div style={{ textAlign: 'right', marginBottom: '2rem' }}>
                    <LangButton
                        onClick={() => setLang('jp')}
                        isActive={lang === 'jp'}
                        style={{ marginRight: '10px' }}
                    >
                        日本語
                    </LangButton>
                    <LangButton onClick={() => setLang('en')} isActive={lang === 'en'}>
                        English
                    </LangButton>
                </div>

                <PolicyHeader
                    title={currentContent.title}
                    subTitle={currentContent.subTitle}
                    lastUpdate={currentContent.lastUpdate}
                />

                <Section title={currentContent.section1Title}>
                    <p className="privacypolicy_contents_body">
                        {currentContent.section1Body}
                    </p>
                </Section>

                <Section title={currentContent.section2Title}>
                    <ul className="privacypolicy_contents_ul">
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section2_1Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section2_2Li}
                        </li>
                    </ul>
                </Section>

                <Section title={currentContent.section3Title}>
                    <ul className="privacypolicy_contents_ul">
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section3_1Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section3_2Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section3_3Li}
                        </li>
                    </ul>
                </Section>

                <Section title={currentContent.section4Title}>
                    <p className="privacypolicy_contents_body">
                        {currentContent.section4Body}
                    </p>
                    <ul className="privacypolicy_contents_ul">
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_1Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_2Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_3Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_4Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_5Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_6Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_7Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section4_8Li}
                        </li>
                    </ul>
                </Section>

                <Section title={currentContent.section5Title}>
                    <p className="privacypolicy_contents_body">
                        {currentContent.section5Body}
                    </p>
                </Section>

                <Section title={currentContent.section6Title}>
                    <ul className="privacypolicy_contents_ul">
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section6_1Li}
                        </li>
                        <li className="privacypolicy_contents_ul_li">
                            {currentContent.section6_2Li}
                        </li>
                    </ul>
                </Section>

                <Section title={currentContent.section7Title}>
                    <p className="privacypolicy_contents_body">
                        {currentContent.section7Body}
                    </p>
                </Section>

                <Section title={currentContent.section8Title}>
                    <p className="privacypolicy_contents_body" style={{ whiteSpace: 'pre-line' }}>
                        {currentContent.section8Body}
                    </p>
                </Section>
            </div>
        </div>
    );
};

export default TukanomaTermsOfService;
